<h2>{{ 'info.end-user-agreement.head' | translate }}</h2>

<p>
NON-EXCLUSIVE DISTRIBUTION LICENSE
</p>
<p>
Ліцензійна угода приєднання до Архіву відкритого доступу (репозиторія) Уманського національного університету садівництва
</p>

<p>1.	Загальні положення</p>
<ul>
<li>
1.1.	Уманський національний університет садівництва (далі – "УНаУС", "Університет") пропонує фізичній особі (далі – "Ліцензіар") використовувати функції Архіву відкритого доступу (репозиторія) УНаУС (далі – "Репозиторій УНаУС") на умовах, викладених у даній ліцензійній угоді приєднання (далі – "Угода"). Угода набуває чинності з моменту висловлення Ліцензіаром згоди з його умовами в порядку, передбаченому п. 1.4 даної Угоди.
</li>
<li>
1.2.	УНаУС пропонує Ліцензіарові доступ до Репозиторія УНаУС з метою розміщення (самоархівування) об’єктів зберігання. Усі послуги УНаУС, пов’язані з Репозиторієм УНаУС, є предметом даної Угоди.
</li>
<li>
1.3.	Використання функцій Репозиторія УНаУС регулюється Тимчасовим положенням про Репозиторій УНаУС, даною Угодою, а також умовами ліцензійних і інших договорів приєднання в області інтелектуальних прав на об’єкти зберігання.
</li>
<li>
1.4.	Починаючи використовувати яку-небудь функцію Репозиторія УНаУС по розміщенню (самоархівуванню) об’єктів зберігання і (або) пройшовши процедуру реєстрації, Ліцензіар вважається таким, що прийняв умови даної Угоди в повному обсязі, без застережень і виключень. У випадку незгоди Ліцензіара з положеннями даної Угоди, він не в праві (не має права) користуватися Репозиторієм УНаУС. У випадку якщо Університетом були внесені зміни в дану Угода в порядку, передбаченому п. 4.1 даної Угоди, з якими Ліцензіар не згодний, він зобов’язано припинити користування Репозиторієм УНаУС.
</li>
</ul>

<p>
2.	Реєстрація Ліцензіара. Обліковий запис Ліцензіара
</p>
<ul>
<li>
2.1.	Для того щоб користуватися функціями Репозиторія УНаУС по розміщенню (самоархівуванню) об’єктів зберігання, Ліцензіарові необхідно пройти процедуру реєстрації зі створенням унікального облікового запису.
</li>
<li>
2.2.	Для реєстрації Ліцензіар зобов’язується надати достовірну і повну інформацію про себе з питань, пропонованих у формі реєстрації, і підтримувати цю інформацію в актуальному стані.
</li>
<li>
2.3.	Персональна інформація Ліцензіара, що міститься в його обліковому записі, зберігається і обробляється УНаУС відповідно до вимог законодавства по роботі з персональними даними.
</li>
<li>
2.4.	При реєстрації Ліцензіар самостійно вибирає собі унікальне символьне ім’я облікового запису і пароль для доступу до неї. УНаУС має право встановлювати вимоги до унікального символьного імені облікового запису і паролю (наприклад, припустимі та неприпустимі символи, особливості імені облікового запису співробітників та студентів УНаУС).
</li>
<li>
2.5.	Ліцензіар самостійно забезпечує конфіденційність свого пароля. Ліцензіар самостійно відповідає за всі дії і їх наслідку в рамках або з використанням функцій Репозиторія УНаУС під його обліковим записом, включаючи випадки передачі Ліцензіаром даних для доступу до облікового запису третім особам, у тому числі по договорах і угодах.
</li>
<li>
2.6.	Усі дії при використанні функцій Репозиторія УНаУС під обліковим записом Ліцензіара вважаються зробленими самим Ліцензіаром, за винятком випадків, коли Ліцензіар, у порядку, передбаченому п. 2.7 даної Угоди, повідомив УНаУС про несанкціонований доступ до його облікового запису і (або) про порушення конфіденційності пароля його обліковому запису.
</li>
<li>
2.7.	Ліцензіар зобов’язаний негайно повідомити УНаУС про всякий несанкціонований, тобто не дозволеним Ліцензіаром, доступ до функцій Репозиторія УНаУС з використанням облікового запису Користувача і (або) про порушення конфіденційності пароля його облікового запису.
</li>
<li>
2.8.	Ліцензіар не має право відтворювати, копіювати, продавати і використовувати для яких-небудь комерційних цілей які-небудь матеріали Репозиторія УНаУС, у тому числі відомості про об’єкти зберігання, доступні Ліцензіарові, за винятком випадків, коли Ліцензіар отримав такий дозвіл від УНаУС, або коли це прямо передбачене умовами ліцензійних і інших договорів в області інтелектуальних прав на об’єкти зберігання.
</li>
<li>
2.9.	Ліцензіар має право в будь-який момент вилучити свій обліковий запис у Репозиторії УНаУС, скориставшись відповідними програмними засобами. При цьому видалення облікового запису може спричинити неможливість використання деяких функцій Репозиторія УНаУС.
</li>
</ul>
<p>
3.	Умови використання функцій Репозиторія УНаУС
</p>
<ul>
<li>
3.1.	Ліцензіар самостійно несе відповідальність перед третіми особами за свої дії, пов’язані з використанням функцій Репозиторія УНаУС, у тому числі, якщо такі дії приведуть до порушення прав і законних інтересів третіх осіб, а також за дотримання законодавства при використанні функцій Репозиторія УНаУС.
</li>
<li>
3.2.	Ліцензіар має право:
</li>
<li>
3.2.1.	підтримувати свою персональну сторінку;
</li>
<li>
3.2.2.	додавати документи в рамках своєї персональної сторінки за допомогою самоархівування;
</li>
<li>
3.2.3.	редагувати свій профіль;
</li>
<li>
3.2.4.	користуватися іншими правами відповідно до даної Угоди.
</li>
<li>
3.3.	При використанні функцій Репозиторія УНаУС Ліцензіар не має права:
</li>
<li>
3.3.1.	завантажувати, розміщувати і (або) поширювати документи та матеріали, які є незаконними, шкідливими, наклепницькими, пропагують насильство і жорстокість, ненависть або дискримінацію людей по расовому, етнічному, половому, релігійному, соціальному ознакам, містять образи на адресу яких-небудь фізичних або юридичних осіб, містять елементи або є пропагандою порнографії, дитячої еротики, являють собою рекламу товарів і послуг, роз’ясняють порядок виготовлення, застосування або іншого використання наркотичних і психотропних речовин або їх аналогів, вибухових речовин або іншої зброї;
</li>
<li>
3.3.2.	завантажувати, розміщувати і (або) поширювати наукові здобутки при відсутності прав на такі дії відповідно до чинного законодавства України і (або) міжнародними договорами України;
</li>
<li>
3.3.3.	робити дії, спрямовані на порушення обмежень і заборон, що накладаються даною Угодою.
</li>
</ul>

<p>
4.	Заключні положення
</p>
<ul>
<li>
4.1.	Угода може бути змінена УНаУС без якого-небудь спеціального повідомлення, нова редакція Угоди набуває чинності з моменту її розміщення в мережі Інтернет по http://lib.udau.edu.ua/, якщо інше не передбачене новою (діючою) редакцією Угоди.
</li>
<li>
4.2.	Питання, не врегульовані даною Угодою, підлягають дозволу відповідно до законодавства України.
</li>
<li>
4.3.	Усі можливі суперечки, що випливають із відносин, регульованих даною Угодою, вирішуються в порядку, установленому чинним законодавством України, по нормах українського права.
</li>
<li>
4.4.	Через безплатність послуг, що надаються у рамках даної Угоди, норми про захист прав споживачів, передбачені законодавством України, не можуть бути застосовані до відносин між Ліцензіаром і УНаУС.
</li>
<li>
4.5.	Ніякі положення даної Угоди не можуть розглядатися в якості встановлення між Ліцензіаром і УНаУС агентських відносин, відносин по спільній діяльності або інших відносин, прямо не передбачених Угодою.
</li>
<li>
4.6.	Неприйняття УНаУС дій у випадку порушення Ліцензіаром або іншими користувачами положень даної Угоди не позбавляє УНаУС права почати відповідні дії в захист своїх інтересів пізніше, а також не означає відмови УНаУС від своїх прав у випадку здійснення надалі подібних або схожих порушень.
</li>
<li>
4.7.	Дана Угода складена на українській та англійській (російській) мовах. Версії Угоди на українській та англійській (російській) мовах автентичні.
</li>
<li>
4.8.	У випадку виявлення різночитань між україномовною версією Угоди і версією Угоди англійською (російською) мовою, застосовуються положення україномовної версії даної Угоди.
</li>
</ul>

